/*
 * LJ Session 5: where_to_buy_click. One delegated listener for the Where to buy panel, the stockist band
 * ([data-wtb-retailer]) and store locator links. Publishes a Shopify custom event for the customer-events
 * pixels to pick up. Never blocks or delays the link and sends nothing itself.
 */
(function () {
  if (window.ljWtbEventsBound) return;
  window.ljWtbEventsBound = true;

  var SELECTOR = '[data-wtb-retailer], a[href*="/pages/store-locator"]';

  function productContext() {
    var el = document.querySelector('[data-wtb-handle]');
    var d = el ? el.dataset : {};
    return { sku: d.wtbSku || '', ean: d.wtbEan || '', product_title: d.wtbTitle || '', product_handle: d.wtbHandle || '' };
  }

  function onClick(event) {
    // auxclick fires for every non-primary button; only the middle button opens a link
    if (event.type === 'auxclick' && event.button !== 1) return;
    try {
      var link = event.target && event.target.closest ? event.target.closest(SELECTOR) : null;
      if (!link) return;
      var publish = window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish;
      if (typeof publish !== 'function') return;

      var d = link.dataset;
      var payload;
      if (d.wtbRetailer) {
        payload = {
          retailer: d.wtbRetailer,
          placement: d.wtbPlacement || '',
          sku: d.wtbSku || '',
          ean: d.wtbEan || '',
          product_title: d.wtbTitle || '',
          product_handle: d.wtbHandle || ''
        };
      } else {
        payload = productContext();
        payload.retailer = 'store_locator';
        payload.placement = link.closest('.announcement-bar') ? 'announcement_bar' : 'page';
      }
      payload.url = link.href || link.getAttribute('href') || '';
      window.Shopify.analytics.publish('where_to_buy_click', payload);
    } catch (e) {
      // never let tracking get in the way of the link
    }
  }

  document.addEventListener('click', onClick, true);
  document.addEventListener('auxclick', onClick, true);
})();
